import { render } from "./PageNotFound.vue?vue&type=template&id=a9ad8406"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/MACOS-START/Projet-RegionPoleEmploi/Appli Inscriptions/inscriptions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__